var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.965,
    height: 127.965,
    viewBox: "0 0 127.965 127.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-745.25 -2824.516)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.242,
    cy: 45.242,
    r: 45.242,
    transform: "translate(745.25 2888.499) rotate(-45)",
    fill: "#1cacf3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(786.322 2863.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.763,90.514a.894.894,0,0,0-.894-.894H96.514a.894.894,0,1,0,0,1.788h5.355A.894.894,0,0,0,102.763,90.514Z",
    transform: "translate(-65.265 -57.481)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.278,19.419V14.954a.894.894,0,0,0-1.788,0v4.465a4.472,4.472,0,0,0,4.465,4.465h8.037V40.847a.894.894,0,0,0,1.784,0V22.99a.894.894,0,0,0-.894-.894h-8.927A2.681,2.681,0,0,1,102.278,19.419Z",
    transform: "translate(-68.351 -9.598)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.678,60.377H91.535a.894.894,0,1,0,0,1.784h7.143a.894.894,0,1,0,0-1.784Z",
    transform: "translate(-62.074 -38.948)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.414,61.267a.89.89,0,0,0-.894-.89H67.165a.894.894,0,1,0,0,1.784H72.52A.894.894,0,0,0,73.414,61.267Z",
    transform: "translate(-46.63 -38.948)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.165,75a.894.894,0,1,0,0,1.784h1.784a.894.894,0,1,0,0-1.784Z",
    transform: "translate(-46.63 -48.213)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.264,47.538H76.19a.894.894,0,0,0,0-1.788H67.264a.894.894,0,0,0,0,1.788Z",
    transform: "translate(-46.729 -29.681)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.983,76.784h8.93a.894.894,0,0,0,0-1.784h-8.93a.894.894,0,0,0,0,1.784Z",
    transform: "translate(-56.093 -48.216)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.415,104.247a.894.894,0,1,0,0,1.784H98.2a.894.894,0,1,0,0-1.784Z",
    transform: "translate(-65.166 -66.749)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.407,89.62H67.264a.894.894,0,0,0,0,1.788h7.143a.894.894,0,1,0,0-1.788Z",
    transform: "translate(-46.729 -57.481)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.308,104.247H67.165a.894.894,0,1,0,0,1.784h7.143a.894.894,0,0,0,0-1.784Z",
    transform: "translate(-46.63 -66.749)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,97.411l-1.788-1.788a3.355,3.355,0,0,0-4.831,0l-11.7,11.7a.894.894,0,0,0-.26.63v5.355a.894.894,0,0,0,.894.894h5.355a.894.894,0,0,0,.63-.26l11.7-11.7a3.271,3.271,0,0,0,0-4.831Zm-7.773,1.894,1.414,1.414-7.755,7.758-1.418-1.418ZM97.4,112.418v-4.1l4.1,4.1Zm5.359-1.264-1.418-1.418,7.758-7.755,1.414,1.414Zm10.172-10.183-1.154,1.154-4.1-4.084,1.154-1.154a1.524,1.524,0,0,1,2.311,0l1.784,1.784a1.505,1.505,0,0,1,0,2.3Z",
    transform: "translate(-65.265 -60.635)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.427,53.663H17.215a2.681,2.681,0,0,1-2.681-2.681V6.345a2.681,2.681,0,0,1,2.681-2.681h28.2l8.667,8.667a.894.894,0,1,0,1.245-1.249L46.413,2.14a.879.879,0,0,0-.63-.26H17.211A4.472,4.472,0,0,0,12.75,6.345V50.982a4.473,4.473,0,0,0,4.465,4.465H40.427a.894.894,0,1,0,0-1.784Z",
    transform: "translate(-12.75 -1.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.407,118.87H67.264a.894.894,0,0,0,0,1.788h7.143a.894.894,0,1,0,0-1.788Z",
    transform: "translate(-46.729 -76.017)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.263,46.644a.894.894,0,0,0-.894-.894H38.014a.894.894,0,0,0-.894.894V52a.894.894,0,0,0,.894.894h5.355A.894.894,0,0,0,44.263,52Zm-1.784,4.465H38.908V47.538h3.571Z",
    transform: "translate(-28.193 -29.681)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.014,111.393h5.355a.894.894,0,0,0,.894-.894v-5.355a.894.894,0,0,0-.894-.894H38.014a.894.894,0,0,0-.894.894V110.5A.894.894,0,0,0,38.014,111.393Zm.894-5.359h3.571v3.571H38.908Z",
    transform: "translate(-28.193 -66.752)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.23,81.814a.894.894,0,0,0,.63.264h.092a.886.886,0,0,0,.652-.4l3.571-5.355a.894.894,0,1,0-1.484-.993l-2.967,4.451L38.707,78.77a.894.894,0,0,0-1.26,1.264Z",
    transform: "translate(-28.256 -48.151)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIco2);
export default __webpack_public_path__ + "static/media/process_ico_2.32c9ec1e9df1829aaa17fc62c9339adc.svg";
export { ForwardRef as ReactComponent };